import {
    View,
    StyleSheet,
} from 'react-native';
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";
import {SectionHeader} from "@/components/organization/SectionHeader";
import {AppDataAchievement} from "@/data/app-data-interfaces";
import {AchievementContent} from "@/components/achievement/AchievementContent";

interface AchievementVerticalListProps {
    achievements: AppDataAchievement[];
    title: string;
    actionText?: string;
    onActionPress?: () => void;
    backgroundColor?: string;
}

export const AchievementVerticalList = ({
                                            achievements,
                                            title,
                                            actionText,
                                            onActionPress,
                                            backgroundColor,
                                        }: AchievementVerticalListProps) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme, backgroundColor);

    if (achievements.length === 0) {
        return null;
    }

    return (
        <View style={styles.container}>
            <SectionHeader
                title={title}
                actionText={actionText}
                onActionPress={onActionPress}
            />
            {achievements.map(achievement => (
                <View style={styles.achievementContainer} key={achievement.id}>
                    <AchievementContent achievement={achievement} size={"sm"}/>
                </View>
            ))}
        </View>
    );
};

const createStyles = (theme: ThemeType, backgroundColor?: string) => StyleSheet.create({
    container: {
        paddingVertical: theme.spacing.lg,
        backgroundColor: backgroundColor || 'transparent',
    },
    achievementContainer: {
        paddingHorizontal: theme.spacing.lg,
        borderBottomWidth: 1,
        borderBottomColor: `${theme.colors.border}40`,
    }
});
